/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Tue, Jul 20th 2021, 8:43:11 pm
 *
 * *****************************************************
 */

import styled from 'styled-components';

export const DividerContainer = styled.div`
  display: flex;
  align-items: center;

  width: 100%;

  hr {
    margin: 0;
    flex-grow: 1;
    border: none;
    border-top: 0.1rem solid var(--p-divider);
  }

  span {
    display: inline-block;
    padding: 0.4rem 0.8rem;
    color: var(--p-text-subdued);
  }
`;
